import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/theme.css';
import './styles/tailwind.css';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element bulunamadı. index.html içinde <div id="root"></div> olduğundan emin olun.');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);
